export default "__VITE_ASSET__15896e6e__"